import { render, staticRenderFns } from "./InfoSite.vue?vue&type=template&id=838a1f96&scoped=true&"
import script from "./InfoSite.vue?vue&type=script&lang=js&"
export * from "./InfoSite.vue?vue&type=script&lang=js&"
import style0 from "./InfoSite.vue?vue&type=style&index=0&id=838a1f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838a1f96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
